import { useState, useEffect, useRef } from "react";

const cars = [
  {
    id: 1, name: "Lamborghini Huracán", category: "Exotic", price: 899, color: "#E8B94F",
    accent: "#FF6B00", emoji: "🏎️",
    specs: { hp: "640 HP", top: "202 mph", seats: 2, fuel: "Petrol" },
    features: ["Carbon Fiber Interior", "Launch Control", "Magnetic Suspension", "Sport Exhaust"],
    gradient: "linear-gradient(135deg, #1a0a00 0%, #3d1800 50%, #1a0a00 100%)",
    svg: (
      <svg viewBox="0 0 320 140" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="bodyGrad1" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#FFD700"/>
            <stop offset="60%" stopColor="#E8B94F"/>
            <stop offset="100%" stopColor="#7A5C00"/>
          </radialGradient>
          <radialGradient id="wheel1" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#555"/>
            <stop offset="70%" stopColor="#222"/>
            <stop offset="100%" stopColor="#111"/>
          </radialGradient>
          <filter id="shadow1"><feDropShadow dx="0" dy="8" stdDeviation="8" floodOpacity="0.5"/></filter>
        </defs>
        <g filter="url(#shadow1)">
          <ellipse cx="160" cy="118" rx="130" ry="12" fill="rgba(0,0,0,0.4)"/>
          <path d="M20 90 L40 72 L80 58 L120 48 L160 44 L200 46 L240 54 L280 70 L300 90 L290 98 L30 98 Z" fill="url(#bodyGrad1)"/>
          <path d="M80 58 L100 38 L140 28 L200 30 L230 48 L240 54" fill="url(#bodyGrad1)" stroke="#FFD700" strokeWidth="0.5"/>
          <polygon points="105,38 115,22 155,18 195,22 225,38 200,30 140,28" fill="#CC9900"/>
          <rect x="108" y="26" width="40" height="14" rx="2" fill="rgba(180,220,255,0.25)" stroke="rgba(100,180,255,0.3)" strokeWidth="0.5"/>
          <rect x="158" y="27" width="38" height="13" rx="2" fill="rgba(180,220,255,0.25)" stroke="rgba(100,180,255,0.3)" strokeWidth="0.5"/>
          <path d="M40 72 L50 72 L55 82 L35 82 Z" fill="#FF4400" opacity="0.9"/>
          <path d="M265 70 L280 70 L285 80 L260 80 Z" fill="#CC2200" opacity="0.8"/>
          <path d="M265 80 L285 80 L295 90 L285 96 L30 96 L22 92 L35 82 L55 82" fill="rgba(180,140,0,0.6)"/>
          <line x1="60" y1="58" x2="55" y2="82" stroke="#CC9900" strokeWidth="1" opacity="0.7"/>
          <line x1="150" y1="44" x2="148" y2="96" stroke="#CC9900" strokeWidth="0.5" opacity="0.5"/>
          <circle cx="72" cy="100" r="16" fill="url(#wheel1)"/>
          <circle cx="72" cy="100" r="12" fill="none" stroke="#888" strokeWidth="4"/>
          <circle cx="72" cy="100" r="5" fill="#aaa"/>
          <circle cx="248" cy="100" r="16" fill="url(#wheel1)"/>
          <circle cx="248" cy="100" r="12" fill="none" stroke="#888" strokeWidth="4"/>
          <circle cx="248" cy="100" r="5" fill="#aaa"/>
          <path d="M260 82 L295 90" stroke="#FFD700" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="46" cy="76" r="3" fill="#FF6600" opacity="0.9"/>
        </g>
      </svg>
    )
  },
  {
    id: 2, name: "Ferrari SF90", category: "Supercar", price: 749, color: "#E63946",
    accent: "#FF1744", emoji: "🏎️",
    specs: { hp: "986 HP", top: "211 mph", seats: 2, fuel: "Hybrid" },
    features: ["Hybrid Powertrain", "eManettino", "F1 DCT", "Active Aero"],
    gradient: "linear-gradient(135deg, #1a0000 0%, #3d0000 50%, #1a0000 100%)",
    svg: (
      <svg viewBox="0 0 320 140" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="bodyGrad2" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#FF4444"/>
            <stop offset="60%" stopColor="#E63946"/>
            <stop offset="100%" stopColor="#7A0000"/>
          </radialGradient>
        </defs>
        <ellipse cx="160" cy="118" rx="130" ry="12" fill="rgba(0,0,0,0.4)"/>
        <path d="M25 88 L50 68 L90 52 L130 44 L165 42 L200 44 L240 52 L275 68 L295 88 L285 96 L35 96 Z" fill="url(#bodyGrad2)"/>
        <path d="M90 52 L110 34 L150 24 L195 26 L225 42 L240 52" fill="#CC0000" stroke="#FF4444" strokeWidth="0.5"/>
        <polygon points="110,34 125,18 160,14 195,18 220,34 195,26 150,24" fill="#AA0000"/>
        <rect x="112" y="22" width="38" height="14" rx="2" fill="rgba(180,220,255,0.25)" stroke="rgba(100,180,255,0.3)" strokeWidth="0.5"/>
        <rect x="158" y="23" width="38" height="13" rx="2" fill="rgba(180,220,255,0.25)" stroke="rgba(100,180,255,0.3)" strokeWidth="0.5"/>
        <path d="M50 68 L62 68 L65 80 L42 80 Z" fill="#FF8800" opacity="0.9"/>
        <path d="M258 66 L275 68 L280 78 L255 78 Z" fill="#CC4400" opacity="0.8"/>
        <circle cx="76" cy="100" r="16" fill="#1a1a1a"/>
        <circle cx="76" cy="100" r="12" fill="none" stroke="#777" strokeWidth="4"/>
        <circle cx="76" cy="100" r="5" fill="#999"/>
        <circle cx="244" cy="100" r="16" fill="#1a1a1a"/>
        <circle cx="244" cy="100" r="12" fill="none" stroke="#777" strokeWidth="4"/>
        <circle cx="244" cy="100" r="5" fill="#999"/>
        <circle cx="48" cy="73" r="3" fill="#FF8800" opacity="0.9"/>
        <path d="M255 80 L280 78 L290 88 L60 88" stroke="#CC0000" strokeWidth="1" opacity="0.5"/>
      </svg>
    )
  },
  {
    id: 3, name: "Porsche 911 GT3", category: "Sports", price: 549, color: "#4FC3F7",
    accent: "#00B0FF", emoji: "🚗",
    specs: { hp: "502 HP", top: "198 mph", seats: 2, fuel: "Petrol" },
    features: ["PDK Gearbox", "Clubsport Package", "Rear-Axle Steering", "PCCB Brakes"],
    gradient: "linear-gradient(135deg, #001020 0%, #002040 50%, #001020 100%)",
    svg: (
      <svg viewBox="0 0 320 140" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="bodyGrad3" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#82D8FF"/>
            <stop offset="60%" stopColor="#4FC3F7"/>
            <stop offset="100%" stopColor="#0060A0"/>
          </radialGradient>
        </defs>
        <ellipse cx="160" cy="118" rx="130" ry="12" fill="rgba(0,0,0,0.4)"/>
        <path d="M30 92 L55 72 L90 58 L120 50 L160 46 L200 48 L240 58 L270 72 L290 90 L280 97 L40 97 Z" fill="url(#bodyGrad3)"/>
        <path d="M95 58 L118 40 L155 32 L195 34 L222 48" fill="#3BA8D8" stroke="#82D8FF" strokeWidth="0.5"/>
        <path d="M195 34 L210 52 L240 58" fill="#3BA8D8"/>
        <rect x="120" y="36" width="35" height="12" rx="2" fill="rgba(180,240,255,0.3)" stroke="rgba(100,200,255,0.4)" strokeWidth="0.5"/>
        <rect x="163" y="37" width="36" height="12" rx="2" fill="rgba(180,240,255,0.3)" stroke="rgba(100,200,255,0.4)" strokeWidth="0.5"/>
        <path d="M55 72 L66 72 L69 82 L45 82 Z" fill="#FF8800" opacity="0.8"/>
        <path d="M255 70 L270 72 L275 82 L252 82 Z" fill="#CC4400" opacity="0.7"/>
        <path d="M220 48 L230 58 L230 78 L220 78" fill="#2080BB" opacity="0.6"/>
        <circle cx="78" cy="100" r="16" fill="#111"/>
        <circle cx="78" cy="100" r="12" fill="none" stroke="#666" strokeWidth="4"/>
        <circle cx="78" cy="100" r="5" fill="#888"/>
        <circle cx="242" cy="100" r="16" fill="#111"/>
        <circle cx="242" cy="100" r="12" fill="none" stroke="#666" strokeWidth="4"/>
        <circle cx="242" cy="100" r="5" fill="#888"/>
        <rect x="250" y="52" width="30" height="4" rx="2" fill="#2060A0" opacity="0.8"/>
        <circle cx="48" cy="76" r="3" fill="#FFAA00" opacity="0.9"/>
      </svg>
    )
  },
  {
    id: 4, name: "Bentley Continental", category: "Luxury", price: 699, color: "#A8D5A2",
    accent: "#4CAF50", emoji: "🚘",
    specs: { hp: "542 HP", top: "207 mph", seats: 4, fuel: "Petrol" },
    features: ["Naim Audio", "Mulliner Handcrafting", "Air Suspension", "Rotating Display"],
    gradient: "linear-gradient(135deg, #001a00 0%, #003300 50%, #001a00 100%)",
    svg: (
      <svg viewBox="0 0 320 140" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="bodyGrad4" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#C8F0C2"/>
            <stop offset="60%" stopColor="#A8D5A2"/>
            <stop offset="100%" stopColor="#3A6A38"/>
          </radialGradient>
        </defs>
        <ellipse cx="160" cy="118" rx="135" ry="12" fill="rgba(0,0,0,0.4)"/>
        <path d="M20 90 L45 70 L80 56 L120 48 L165 46 L210 48 L250 56 L285 70 L300 90 L290 98 L30 98 Z" fill="url(#bodyGrad4)"/>
        <path d="M80 56 L100 38 L145 28 L200 30 L240 46 L250 56" fill="#7AB878" stroke="#C8F0C2" strokeWidth="0.5"/>
        <path d="M100 38 L115 22 L155 16 L205 20 L230 38" fill="#5A9858"/>
        <rect x="115" y="22" width="40" height="16" rx="2" fill="rgba(200,240,220,0.2)" stroke="rgba(150,220,170,0.3)" strokeWidth="0.5"/>
        <rect x="163" y="24" width="44" height="15" rx="2" fill="rgba(200,240,220,0.2)" stroke="rgba(150,220,170,0.3)" strokeWidth="0.5"/>
        <path d="M45 70 L58 70 L62 82 L38 82 Z" fill="#FFAA00" opacity="0.9"/>
        <path d="M262 68 L278 70 L283 82 L258 82 Z" fill="#CC6600" opacity="0.8"/>
        <rect x="130" y="16" width="8" height="6" rx="1" fill="#888" opacity="0.7"/>
        <circle cx="70" cy="100" r="18" fill="#0a0a0a"/>
        <circle cx="70" cy="100" r="14" fill="none" stroke="#555" strokeWidth="5"/>
        <circle cx="70" cy="100" r="6" fill="#777"/>
        <circle cx="250" cy="100" r="18" fill="#0a0a0a"/>
        <circle cx="250" cy="100" r="14" fill="none" stroke="#555" strokeWidth="5"/>
        <circle cx="250" cy="100" r="6" fill="#777"/>
        <circle cx="40" cy="74" r="3.5" fill="#FFBB00" opacity="0.9"/>
        <circle cx="280" cy="74" r="3.5" fill="#FF4400" opacity="0.7"/>
      </svg>
    )
  },
  {
    id: 5, name: "McLaren 720S", category: "Supercar", price: 829, color: "#CE93D8",
    accent: "#AB47BC", emoji: "🚀",
    specs: { hp: "710 HP", top: "212 mph", seats: 2, fuel: "Petrol" },
    features: ["Proactive Chassis", "Folding Doors", "Carbon MonoCell", "Active Spoiler"],
    gradient: "linear-gradient(135deg, #0a0020 0%, #1a0040 50%, #0a0020 100%)",
    svg: (
      <svg viewBox="0 0 320 140" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="bodyGrad5" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#E8B0F8"/>
            <stop offset="60%" stopColor="#CE93D8"/>
            <stop offset="100%" stopColor="#6A1A8A"/>
          </radialGradient>
        </defs>
        <ellipse cx="160" cy="118" rx="128" ry="11" fill="rgba(0,0,0,0.4)"/>
        <path d="M22 92 L42 70 L80 54 L125 44 L165 42 L205 44 L245 54 L278 70 L298 90 L286 97 L34 97 Z" fill="url(#bodyGrad5)"/>
        <path d="M80 54 L95 32 L140 22 L195 24 L232 44 L245 54" fill="#A060C0" stroke="#E8B0F8" strokeWidth="0.5"/>
        <path d="M95 32 L108 14 L155 8 L200 12 L228 32" fill="#7A30A0"/>
        <rect x="108" y="16" width="42" height="16" rx="3" fill="rgba(220,180,255,0.2)" stroke="rgba(180,120,255,0.35)" strokeWidth="0.5"/>
        <rect x="162" y="18" width="42" height="14" rx="3" fill="rgba(220,180,255,0.2)" stroke="rgba(180,120,255,0.35)" strokeWidth="0.5"/>
        <path d="M42 70 L54 70 L56 84 L36 84 Z" fill="#FF8800" opacity="0.9"/>
        <path d="M260 68 L276 70 L280 82 L257 82 Z" fill="#FF4400" opacity="0.8"/>
        <path d="M230 44 L244 54 L244 80 L232 80 Z" fill="#8840B0" opacity="0.5"/>
        <path d="M88 54 L96 32" stroke="#E8B0F8" strokeWidth="1" opacity="0.6"/>
        <circle cx="68" cy="100" r="17" fill="#111"/>
        <circle cx="68" cy="100" r="13" fill="none" stroke="#664488" strokeWidth="4"/>
        <circle cx="68" cy="100" r="5" fill="#886699"/>
        <circle cx="252" cy="100" r="17" fill="#111"/>
        <circle cx="252" cy="100" r="13" fill="none" stroke="#664488" strokeWidth="4"/>
        <circle cx="252" cy="100" r="5" fill="#886699"/>
        <path d="M200 8 L224 12" stroke="#E8B0F8" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
      </svg>
    )
  },
  {
    id: 6, name: "Rolls-Royce Ghost", category: "Ultra Luxury", price: 999, color: "#F48FB1",
    accent: "#E91E63", emoji: "👑",
    specs: { hp: "563 HP", top: "155 mph", seats: 5, fuel: "Petrol" },
    features: ["Starlight Headliner", "Bespoke Audio", "Magic Carpet Ride", "Spirit of Ecstasy"],
    gradient: "linear-gradient(135deg, #1a001a 0%, #3d0030 50%, #1a001a 100%)",
    svg: (
      <svg viewBox="0 0 320 140" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <radialGradient id="bodyGrad6" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#FFCCE0"/>
            <stop offset="60%" stopColor="#F48FB1"/>
            <stop offset="100%" stopColor="#7A0040"/>
          </radialGradient>
        </defs>
        <ellipse cx="160" cy="120" rx="140" ry="13" fill="rgba(0,0,0,0.5)"/>
        <path d="M15 88 L40 66 L75 52 L120 46 L165 44 L215 46 L258 54 L288 72 L305 90 L295 100 L25 100 Z" fill="url(#bodyGrad6)"/>
        <path d="M75 52 L90 36 L130 26 L200 28 L240 44 L258 54" fill="#C06090" stroke="#FFCCE0" strokeWidth="0.5"/>
        <path d="M90 36 L100 20 L145 14 L210 18 L238 36" fill="#A04070"/>
        <rect x="105" y="22" width="42" height="16" rx="2" fill="rgba(255,220,240,0.2)" stroke="rgba(255,160,200,0.3)" strokeWidth="0.5"/>
        <rect x="155" y="24" width="46" height="15" rx="2" fill="rgba(255,220,240,0.2)" stroke="rgba(255,160,200,0.3)" strokeWidth="0.5"/>
        <path d="M40 66 L55 66 L60 80 L34 80 Z" fill="#FFAA00" opacity="0.9"/>
        <path d="M265 70 L283 72 L288 82 L262 82 Z" fill="#CC6600" opacity="0.8"/>
        <rect x="145" y="12" width="10" height="10" rx="1" fill="#C0A040" opacity="0.8"/>
        <line x1="150" y1="10" x2="150" y2="2" stroke="#C0A040" strokeWidth="1.5" opacity="0.8"/>
        <circle cx="68" cy="102" r="18" fill="#0a0a0a"/>
        <circle cx="68" cy="102" r="14" fill="none" stroke="#443344" strokeWidth="5"/>
        <circle cx="68" cy="102" r="6" fill="#664466"/>
        <circle cx="252" cy="102" r="18" fill="#0a0a0a"/>
        <circle cx="252" cy="102" r="14" fill="none" stroke="#443344" strokeWidth="5"/>
        <circle cx="252" cy="102" r="6" fill="#664466"/>
        <circle cx="34" cy="72" r="4" fill="#FFCC00" opacity="0.9"/>
        <circle cx="288" cy="75" r="3.5" fill="#FF4400" opacity="0.7"/>
        <path d="M200 28 L215 46" stroke="#FFCCE0" strokeWidth="0.5" opacity="0.5"/>
      </svg>
    )
  },
];

const partCategories = [
  { icon: "⚙️", name: "Engine", desc: "V8 to V12 Powerplants" },
  { icon: "🛞", name: "Wheels", desc: "Forged Alloy Sets" },
  { icon: "🔧", name: "Suspension", desc: "Adaptive Dampers" },
  { icon: "💨", name: "Exhaust", desc: "Sport & Race Systems" },
  { icon: "🛡️", name: "Aero Kits", desc: "Carbon Fiber Packages" },
  { icon: "🪑", name: "Interior", desc: "Bespoke Upholstery" },
];

const testimonials = [
  { name: "Ahmed Al-Rashid", role: "CEO, Gulf Ventures", text: "An absolutely transcendent experience. The Lamborghini was delivered immaculate, and the concierge service was beyond expectations.", stars: 5 },
  { name: "Sarah Mitchell", role: "Travel Influencer", text: "GoRoute transformed my Dubai trip. Rolled up in a Ferrari and felt like royalty everywhere I went. 10/10 would book again.", stars: 5 },
  { name: "Marcus Chen", role: "Formula 1 Enthusiast", text: "Track day package with the McLaren was insane. The car was in perfect mechanical condition and the team was incredibly professional.", stars: 5 },
];

export default function GoRoute() {
  const [activeCarIdx, setActiveCarIdx] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("overview");
  const [bookingStep, setBookingStep] = useState(0);
  const [hoveredPart, setHoveredPart] = useState(null);
  const [particles, setParticles] = useState([]);
  const heroRef = useRef(null);
  const carouselRef = useRef(null);

  const car = cars[activeCarIdx];

  useEffect(() => {
    const ps = Array.from({ length: 30 }, (_, i) => ({
      id: i, x: Math.random() * 100, y: Math.random() * 100,
      size: Math.random() * 3 + 1, speed: Math.random() * 2 + 0.5,
      opacity: Math.random() * 0.6 + 0.2, delay: Math.random() * 4,
    }));
    setParticles(ps);
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goToCar = (idx) => {
    if (animating || idx === activeCarIdx) return;
    setAnimating(true);
    setTimeout(() => { setActiveCarIdx(idx); setAnimating(false); setSelectedTab("overview"); }, 350);
  };

  const nextCar = () => goToCar((activeCarIdx + 1) % cars.length);
  const prevCar = () => goToCar((activeCarIdx - 1 + cars.length) % cars.length);

  const styles = {
    root: {
      fontFamily: "'Cormorant Garamond', 'Playfair Display', Georgia, serif",
      background: "#020408",
      color: "#F0EDE8",
      overflowX: "hidden",
      minHeight: "100vh",
    },
    nav: {
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
      padding: "1.2rem 3rem",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      background: scrollY > 60 ? "rgba(2,4,8,0.95)" : "transparent",
      backdropFilter: scrollY > 60 ? "blur(20px)" : "none",
      borderBottom: scrollY > 60 ? "1px solid rgba(255,255,255,0.08)" : "none",
      transition: "all 0.5s ease",
    },
    logo: {
      fontSize: "1.8rem", fontWeight: 700, letterSpacing: "0.12em",
      background: `linear-gradient(135deg, ${car.color}, ${car.accent})`,
      WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
      textTransform: "uppercase",
    },
    navLinks: {
      display: "flex", gap: "2.5rem", listStyle: "none", padding: 0, margin: 0,
    },
    navLink: {
      fontSize: "0.78rem", letterSpacing: "0.2em", textTransform: "uppercase",
      color: "rgba(240,237,232,0.7)", cursor: "pointer",
      transition: "color 0.3s", textDecoration: "none",
      fontFamily: "'Montserrat', 'Arial', sans-serif",
    },
    navBtn: {
      padding: "0.6rem 1.8rem", fontSize: "0.75rem", letterSpacing: "0.2em",
      textTransform: "uppercase", fontFamily: "'Montserrat', sans-serif",
      background: `linear-gradient(135deg, ${car.color}, ${car.accent})`,
      border: "none", borderRadius: "2px", color: "#000",
      cursor: "pointer", fontWeight: 700, transition: "all 0.3s",
    },
    hero: {
      minHeight: "100vh", position: "relative", display: "flex",
      flexDirection: "column", justifyContent: "center",
      overflow: "hidden",
    },
    heroBackground: {
      position: "absolute", inset: 0,
      background: car.gradient,
      transition: "background 0.8s ease",
    },
    gridLines: {
      position: "absolute", inset: 0, opacity: 0.06,
      backgroundImage: `
        linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)
      `,
      backgroundSize: "60px 60px",
    },
    heroContent: {
      position: "relative", zIndex: 10, padding: "0 5rem",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      gap: "4rem", paddingTop: "100px",
    },
    heroLeft: { flex: 1, maxWidth: "520px" },
    categoryBadge: {
      display: "inline-block", padding: "0.35rem 1rem",
      fontSize: "0.7rem", letterSpacing: "0.3em", textTransform: "uppercase",
      fontFamily: "'Montserrat', sans-serif", fontWeight: 600,
      border: `1px solid ${car.color}`, color: car.color, borderRadius: "2px",
      marginBottom: "1.5rem", transition: "all 0.4s",
    },
    heroTitle: {
      fontSize: "clamp(2.5rem, 5vw, 4rem)", lineHeight: 1.05,
      fontWeight: 700, letterSpacing: "-0.01em", marginBottom: "1rem",
      opacity: animating ? 0 : 1, transform: animating ? "translateY(20px)" : "translateY(0)",
      transition: "all 0.35s ease",
    },
    heroPrice: {
      fontSize: "1rem", color: "rgba(240,237,232,0.5)",
      fontFamily: "'Montserrat', sans-serif", letterSpacing: "0.1em",
      marginBottom: "2rem",
    },
    priceNum: {
      fontSize: "2rem", fontWeight: 700, color: car.color, transition: "color 0.4s",
    },
    heroActions: { display: "flex", gap: "1rem", alignItems: "center", marginBottom: "3rem" },
    primaryBtn: {
      padding: "1rem 2.5rem", fontSize: "0.8rem", letterSpacing: "0.2em",
      textTransform: "uppercase", fontFamily: "'Montserrat', sans-serif",
      background: `linear-gradient(135deg, ${car.color}, ${car.accent})`,
      border: "none", borderRadius: "2px", color: "#000",
      cursor: "pointer", fontWeight: 700, transition: "all 0.3s",
      boxShadow: `0 8px 32px ${car.color}44`,
    },
    secondaryBtn: {
      padding: "1rem 2.5rem", fontSize: "0.8rem", letterSpacing: "0.2em",
      textTransform: "uppercase", fontFamily: "'Montserrat', sans-serif",
      background: "transparent", border: "1px solid rgba(240,237,232,0.3)",
      borderRadius: "2px", color: "#F0EDE8", cursor: "pointer", fontWeight: 600,
      transition: "all 0.3s",
    },
    specBar: {
      display: "flex", gap: "2rem",
    },
    specItem: {
      display: "flex", flexDirection: "column", gap: "0.3rem",
    },
    specLabel: {
      fontSize: "0.65rem", letterSpacing: "0.2em", textTransform: "uppercase",
      color: "rgba(240,237,232,0.4)", fontFamily: "'Montserrat', sans-serif",
    },
    specVal: {
      fontSize: "1.1rem", fontWeight: 700, color: car.color, transition: "color 0.4s",
    },
    heroRight: {
      flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
      gap: "2rem", position: "relative",
    },
    carDisplay: {
      width: "100%", maxWidth: "460px",
      opacity: animating ? 0 : 1, transform: animating ? "translateX(40px) scale(0.95)" : "translateX(0) scale(1)",
      transition: "all 0.35s ease",
    },
    carControls: {
      display: "flex", gap: "1rem", alignItems: "center",
    },
    arrowBtn: {
      width: "48px", height: "48px", borderRadius: "50%",
      background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)",
      color: "#F0EDE8", fontSize: "1.2rem", cursor: "pointer",
      display: "flex", alignItems: "center", justifyContent: "center",
      transition: "all 0.3s",
    },
    dotsContainer: { display: "flex", gap: "0.5rem" },
    dot: (active) => ({
      width: active ? "24px" : "8px", height: "8px", borderRadius: "4px",
      background: active ? car.color : "rgba(255,255,255,0.25)",
      transition: "all 0.4s ease", cursor: "pointer",
    }),
    section: {
      padding: "8rem 5rem",
      position: "relative",
    },
    sectionTitle: {
      fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 700, marginBottom: "0.5rem",
      textAlign: "center",
    },
    sectionSub: {
      textAlign: "center", color: "rgba(240,237,232,0.5)",
      fontFamily: "'Montserrat', sans-serif", fontSize: "0.8rem",
      letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: "4rem",
    },
    accent: { color: car.color, transition: "color 0.4s" },
    fleetGrid: {
      display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1.5rem",
    },
    carCard: (active) => ({
      background: active ? `linear-gradient(135deg, ${car.gradient.split("(")[1].split(",")[0].trim()}, rgba(255,255,255,0.03))` : "rgba(255,255,255,0.03)",
      border: active ? `1px solid ${car.color}55` : "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px", padding: "1.5rem", cursor: "pointer",
      transition: "all 0.4s ease",
      transform: active ? "translateY(-4px)" : "translateY(0)",
      boxShadow: active ? `0 20px 60px ${car.color}22` : "none",
    }),
    tabBar: {
      display: "flex", gap: "0", borderBottom: "1px solid rgba(255,255,255,0.1)",
      marginBottom: "2rem",
    },
    tab: (active) => ({
      padding: "0.75rem 1.5rem", fontSize: "0.75rem", letterSpacing: "0.15em",
      textTransform: "uppercase", fontFamily: "'Montserrat', sans-serif",
      cursor: "pointer", border: "none", background: "transparent",
      color: active ? car.color : "rgba(240,237,232,0.4)",
      borderBottom: active ? `2px solid ${car.color}` : "2px solid transparent",
      transition: "all 0.3s", marginBottom: "-1px",
    }),
    partsGrid: {
      display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1.5rem",
    },
    partCard: (hovered) => ({
      background: hovered ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.03)",
      border: hovered ? `1px solid ${car.color}44` : "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px", padding: "2rem 1.5rem", cursor: "pointer",
      transition: "all 0.35s ease", textAlign: "center",
      transform: hovered ? "translateY(-6px)" : "translateY(0)",
    }),
    partEmoji: { fontSize: "2.5rem", display: "block", marginBottom: "1rem" },
    partName: { fontSize: "1.2rem", fontWeight: 600, marginBottom: "0.5rem" },
    partDesc: {
      fontSize: "0.8rem", color: "rgba(240,237,232,0.5)",
      fontFamily: "'Montserrat', sans-serif",
    },
    statsSection: {
      background: "rgba(255,255,255,0.02)",
      borderTop: "1px solid rgba(255,255,255,0.08)",
      borderBottom: "1px solid rgba(255,255,255,0.08)",
      padding: "5rem",
    },
    statsGrid: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "2rem" },
    statCard: {
      textAlign: "center", padding: "2rem",
    },
    statNum: {
      fontSize: "3.5rem", fontWeight: 700, lineHeight: 1,
      background: `linear-gradient(135deg, ${car.color}, ${car.accent})`,
      WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
      transition: "all 0.4s", marginBottom: "0.5rem",
    },
    statLabel: {
      fontSize: "0.75rem", letterSpacing: "0.2em", textTransform: "uppercase",
      color: "rgba(240,237,232,0.5)", fontFamily: "'Montserrat', sans-serif",
    },
    testimonialsGrid: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "2rem" },
    testimonialCard: {
      background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px", padding: "2rem",
    },
    stars: { color: car.color, fontSize: "1rem", marginBottom: "1rem", transition: "color 0.4s" },
    testimonialText: {
      fontSize: "0.95rem", lineHeight: 1.7, color: "rgba(240,237,232,0.8)",
      marginBottom: "1.5rem", fontStyle: "italic",
    },
    testimonialAuthor: { fontSize: "1rem", fontWeight: 600 },
    testimonialRole: {
      fontSize: "0.75rem", color: "rgba(240,237,232,0.5)",
      fontFamily: "'Montserrat', sans-serif", letterSpacing: "0.1em",
    },
    bookingSection: {
      background: car.gradient, transition: "background 0.8s",
      padding: "8rem 5rem", textAlign: "center",
    },
    bookingCard: {
      maxWidth: "700px", margin: "0 auto",
      background: "rgba(0,0,0,0.5)", borderRadius: "12px",
      padding: "3rem", border: "1px solid rgba(255,255,255,0.1)",
      backdropFilter: "blur(20px)",
    },
    stepIndicator: { display: "flex", justifyContent: "center", gap: "1rem", marginBottom: "2.5rem" },
    step: (active, done) => ({
      width: "32px", height: "32px", borderRadius: "50%",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: "0.8rem", fontWeight: 700, fontFamily: "'Montserrat', sans-serif",
      background: done ? car.color : active ? "rgba(255,255,255,0.15)" : "rgba(255,255,255,0.05)",
      border: active ? `2px solid ${car.color}` : done ? `2px solid ${car.color}` : "2px solid rgba(255,255,255,0.15)",
      color: done ? "#000" : "#F0EDE8", transition: "all 0.4s",
    }),
    stepLine: {
      height: "2px", width: "60px", alignSelf: "center",
      background: "rgba(255,255,255,0.15)", borderRadius: "1px",
    },
    inputGroup: { marginBottom: "1.5rem", textAlign: "left" },
    inputLabel: {
      display: "block", fontSize: "0.7rem", letterSpacing: "0.2em",
      textTransform: "uppercase", fontFamily: "'Montserrat', sans-serif",
      color: "rgba(240,237,232,0.6)", marginBottom: "0.5rem",
    },
    input: {
      width: "100%", padding: "0.85rem 1rem",
      background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "4px", color: "#F0EDE8",
      fontFamily: "'Montserrat', sans-serif", fontSize: "0.9rem",
      outline: "none", boxSizing: "border-box",
    },
    inputRow: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" },
    footer: {
      background: "#010204", padding: "5rem", borderTop: "1px solid rgba(255,255,255,0.06)",
    },
    footerGrid: { display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: "4rem", marginBottom: "3rem" },
    footerBrand: { fontSize: "1.5rem", fontWeight: 700, letterSpacing: "0.1em", marginBottom: "1rem" },
    footerDesc: {
      fontSize: "0.85rem", color: "rgba(240,237,232,0.4)", lineHeight: 1.7,
      fontFamily: "'Montserrat', sans-serif",
    },
    footerHeading: {
      fontSize: "0.7rem", letterSpacing: "0.25em", textTransform: "uppercase",
      fontFamily: "'Montserrat', sans-serif", color: car.color,
      marginBottom: "1.5rem", transition: "color 0.4s",
    },
    footerLinks: { listStyle: "none", padding: 0, margin: 0 },
    footerLink: {
      fontSize: "0.85rem", color: "rgba(240,237,232,0.5)",
      marginBottom: "0.75rem", cursor: "pointer",
      fontFamily: "'Montserrat', sans-serif",
      transition: "color 0.2s",
    },
    footerBottom: {
      borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "2rem",
      display: "flex", justifyContent: "space-between", alignItems: "center",
    },
    footerCopy: {
      fontSize: "0.75rem", color: "rgba(240,237,232,0.3)",
      fontFamily: "'Montserrat', sans-serif",
    },
    featureList: {
      display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem", marginTop: "1.5rem",
    },
    featureItem: {
      display: "flex", alignItems: "center", gap: "0.75rem",
      fontSize: "0.9rem", color: "rgba(240,237,232,0.8)",
    },
    featureDot: {
      width: "6px", height: "6px", borderRadius: "50%",
      background: car.color, flexShrink: 0, transition: "background 0.4s",
    },
    speedLine: {
      position: "absolute", bottom: "40px", left: "0", right: "0",
      display: "flex", justifyContent: "center", gap: "6px", alignItems: "center",
    },
    line: (i) => ({
      height: "2px", borderRadius: "1px",
      background: `linear-gradient(90deg, transparent, ${car.color}, transparent)`,
      opacity: 0.4, transition: "background 0.4s",
      width: `${[80, 120, 200, 120, 80][i] || 60}px`,
      animation: `speedLine${i} 2s ease-in-out infinite`,
      animationDelay: `${i * 0.3}s`,
    }),
  };

  const bookingSteps = ["Vehicle", "Details", "Confirm"];

  return (
    <div style={styles.root}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Montserrat:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        ::selection { background: ${car.color}44; }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #010204; }
        ::-webkit-scrollbar-thumb { background: ${car.color}66; border-radius: 3px; }
        @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }
        @keyframes pulse { 0%,100%{opacity:0.4} 50%{opacity:0.8} }
        @keyframes carFloat { 0%,100%{transform:translateY(0) rotate(-1deg)} 50%{transform:translateY(-10px) rotate(1deg)} }
        @keyframes speedLine0 { 0%,100%{transform:scaleX(0.5);opacity:0.2} 50%{transform:scaleX(1.2);opacity:0.5} }
        @keyframes speedLine1 { 0%,100%{transform:scaleX(0.6);opacity:0.3} 50%{transform:scaleX(1.3);opacity:0.6} }
        @keyframes speedLine2 { 0%,100%{transform:scaleX(0.8);opacity:0.4} 50%{transform:scaleX(1.1);opacity:0.7} }
        @keyframes speedLine3 { 0%,100%{transform:scaleX(0.6);opacity:0.3} 50%{transform:scaleX(1.3);opacity:0.6} }
        @keyframes speedLine4 { 0%,100%{transform:scaleX(0.5);opacity:0.2} 50%{transform:scaleX(1.2);opacity:0.5} }
        @keyframes shimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
        .hover-glow:hover { box-shadow: 0 0 30px ${car.color}44 !important; transform: translateY(-2px) !important; }
        .nav-link-hover:hover { color: ${car.color} !important; }
        .arrow-hover:hover { background: rgba(255,255,255,0.15) !important; transform: scale(1.1); }
        .footer-link-hover:hover { color: ${car.color} !important; }
      `}</style>

      {/* NAV */}
      <nav style={styles.nav}>
        <div style={styles.logo}>GoRoute</div>
        <ul style={styles.navLinks}>
          {["Fleet", "Services", "Experience", "Contact"].map(l => (
            <li key={l}><a style={styles.navLink} className="nav-link-hover">{l}</a></li>
          ))}
        </ul>
        <button style={styles.navBtn} className="hover-glow">Reserve Now</button>
      </nav>

      {/* HERO */}
      <section style={styles.hero} ref={heroRef}>
        <div style={styles.heroBackground} />
        <div style={styles.gridLines} />
        {particles.map(p => (
          <div key={p.id} style={{
            position: "absolute", left: `${p.x}%`, top: `${p.y}%`,
            width: `${p.size}px`, height: `${p.size}px`, borderRadius: "50%",
            background: car.color, opacity: p.opacity * 0.5,
            animation: `pulse ${p.speed + 1}s ease-in-out infinite`,
            animationDelay: `${p.delay}s`, transition: "background 0.4s",
          }} />
        ))}

        <div style={styles.heroContent}>
          <div style={styles.heroLeft}>
            <div style={styles.categoryBadge}>{car.category}</div>
            <h1 style={styles.heroTitle}>{car.name}</h1>
            <p style={styles.heroPrice}>
              From <span style={styles.priceNum}>ريال{car.price}</span> / day
            </p>
            <div style={styles.specBar}>
              {Object.entries(car.specs).map(([k, v]) => (
                <div key={k} style={styles.specItem}>
                  <span style={styles.specLabel}>{k}</span>
                  <span style={styles.specVal}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: "2.5rem", ...styles.heroActions }}>
              <button style={styles.primaryBtn} className="hover-glow"
                onClick={() => setBookingStep(0)}>
                Reserve This Car
              </button>
              <button style={styles.secondaryBtn} className="hover-glow"
                onClick={() => setSelectedTab("specs")}>
                View Specs
              </button>
            </div>
          </div>

          <div style={styles.heroRight}>
            <div style={{ ...styles.carDisplay, animation: "carFloat 4s ease-in-out infinite" }}>
              {car.svg}
            </div>
            <div style={styles.carControls}>
              <button style={styles.arrowBtn} className="arrow-hover" onClick={prevCar}>‹</button>
              <div style={styles.dotsContainer}>
                {cars.map((_, i) => (
                  <div key={i} style={styles.dot(i === activeCarIdx)} onClick={() => goToCar(i)} />
                ))}
              </div>
              <button style={styles.arrowBtn} className="arrow-hover" onClick={nextCar}>›</button>
            </div>
          </div>
        </div>

        <div style={styles.speedLine}>
          {[0,1,2,3,4].map(i => <div key={i} style={styles.line(i)} />)}
        </div>
      </section>

      {/* FLEET SECTION */}
      <section style={{ ...styles.section, background: "#030609" }}>
        <p style={styles.sectionSub}>Our Collection</p>
        <h2 style={styles.sectionTitle}>The <span style={styles.accent}>Fleet</span></h2>
        <div style={{ height: "0.5px", background: `linear-gradient(90deg, transparent, ${car.color}, transparent)`, margin: "2rem auto 3rem", width: "200px", transition: "background 0.4s" }} />

        {/* Tabs */}
        <div style={{ maxWidth: "800px", margin: "0 auto 3rem" }}>
          <div style={styles.tabBar}>
            {["overview", "specs", "features"].map(tab => (
              <button key={tab} style={styles.tab(selectedTab === tab)}
                onClick={() => setSelectedTab(tab)}>
                {tab}
              </button>
            ))}
          </div>

          {selectedTab === "overview" && (
            <div style={{ display: "flex", gap: "3rem", alignItems: "center" }}>
              <div style={{ flex: 1, maxWidth: "280px", animation: "carFloat 5s ease-in-out infinite" }}>
                {car.svg}
              </div>
              <div style={{ flex: 1 }}>
                <div style={styles.categoryBadge}>{car.category}</div>
                <h3 style={{ fontSize: "2rem", marginBottom: "1rem" }}>{car.name}</h3>
                <p style={{ color: "rgba(240,237,232,0.6)", fontSize: "0.9rem", fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8, marginBottom: "1.5rem" }}>
                  Experience the pinnacle of automotive engineering. Every detail meticulously crafted for those who demand nothing short of perfection on every road.
                </p>
                <div style={styles.featureList}>
                  {car.features.map(f => (
                    <div key={f} style={styles.featureItem}>
                      <div style={styles.featureDot} />
                      {f}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {selectedTab === "specs" && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "1.5rem" }}>
              {Object.entries(car.specs).map(([k, v]) => (
                <div key={k} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", padding: "1.5rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "0.75rem", letterSpacing: "0.15em", textTransform: "uppercase", color: "rgba(240,237,232,0.5)" }}>{k}</span>
                  <span style={{ fontSize: "1.4rem", fontWeight: 700, color: car.color, transition: "color 0.4s" }}>{v}</span>
                </div>
              ))}
              <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", padding: "1.5rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "0.75rem", letterSpacing: "0.15em", textTransform: "uppercase", color: "rgba(240,237,232,0.5)" }}>Daily Rate</span>
                <span style={{ fontSize: "1.4rem", fontWeight: 700, color: car.color, transition: "color 0.4s" }}>${car.price}</span>
              </div>
            </div>
          )}

          {selectedTab === "features" && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
              {car.features.map((f, i) => (
                <div key={f} style={{ background: "rgba(255,255,255,0.04)", border: `1px solid ${car.color}33`, borderRadius: "8px", padding: "1.5rem", display: "flex", alignItems: "center", gap: "1rem", transition: "border-color 0.4s" }}>
                  <div style={{ width: "40px", height: "40px", borderRadius: "50%", background: `${car.color}22`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.2rem", flexShrink: 0, transition: "background 0.4s" }}>
                    {["⚡","🔬","🎯","🛡️"][i % 4]}
                  </div>
                  <span style={{ fontSize: "0.95rem", fontWeight: 600 }}>{f}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Fleet Grid */}
        <div style={styles.fleetGrid}>
          {cars.map((c, i) => (
            <div key={c.id} style={styles.carCard(i === activeCarIdx)} onClick={() => goToCar(i)} className="hover-glow">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}>
                <div>
                  <div style={{ fontSize: "0.65rem", letterSpacing: "0.2em", textTransform: "uppercase", color: c.color, fontFamily: "'Montserrat', sans-serif", marginBottom: "0.4rem" }}>{c.category}</div>
                  <div style={{ fontSize: "1.1rem", fontWeight: 600 }}>{c.name.split(" ").slice(-1)[0]}</div>
                </div>
                <div style={{ fontSize: "1.4rem", fontWeight: 700, color: c.color }}>${c.price}<span style={{ fontSize: "0.7rem", color: "rgba(240,237,232,0.4)", fontFamily: "'Montserrat', sans-serif" }}>/day</span></div>
              </div>
              <div style={{ transform: "scale(0.8)", transformOrigin: "center" }}>{c.svg}</div>
              <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
                {Object.values(c.specs).slice(0, 2).map((v, j) => (
                  <span key={j} style={{ fontSize: "0.7rem", padding: "0.25rem 0.6rem", background: "rgba(255,255,255,0.07)", borderRadius: "2px", fontFamily: "'Montserrat', sans-serif", color: "rgba(240,237,232,0.7)" }}>{v}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* STATS */}
      <section style={styles.statsSection}>
        <div style={styles.statsGrid}>
          {[
            { num: "250+", label: "Exotic Vehicles" },
            { num: "15K+", label: "Happy Clients" },
            { num: "98%", label: "Satisfaction Rate" },
            { num: "24/7", label: "Concierge Service" },
          ].map(s => (
            <div key={s.label} style={styles.statCard}>
              <div style={styles.statNum}>{s.num}</div>
              <div style={styles.statLabel}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* PARTS & THEMES */}
      <section style={{ ...styles.section, background: "#020508" }}>
        <p style={styles.sectionSub}>Accessories & Add-Ons</p>
        <h2 style={styles.sectionTitle}>Car <span style={styles.accent}>Parts & Themes</span></h2>
        <div style={{ height: "0.5px", background: `linear-gradient(90deg, transparent, ${car.color}, transparent)`, margin: "2rem auto 3rem", width: "200px", transition: "background 0.4s" }} />

        <div style={styles.partsGrid}>
          {partCategories.map((p, i) => (
            <div key={p.name} style={styles.partCard(hoveredPart === i)}
              onMouseEnter={() => setHoveredPart(i)}
              onMouseLeave={() => setHoveredPart(null)}>
              <span style={styles.partEmoji}>{p.icon}</span>
              <div style={styles.partName}>{p.name}</div>
              <div style={styles.partDesc}>{p.desc}</div>
              {hoveredPart === i && (
                <div style={{ marginTop: "1.5rem" }}>
                  <button style={{ ...styles.secondaryBtn, padding: "0.6rem 1.5rem", fontSize: "0.7rem" }}>
                    Explore →
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Theme color swatches */}
        <div style={{ marginTop: "4rem", textAlign: "center" }}>
          <p style={{ ...styles.sectionSub, marginBottom: "2rem" }}>Vehicle Colour Themes</p>
          <div style={{ display: "flex", justifyContent: "center", gap: "1.5rem", flexWrap: "wrap" }}>
            {cars.map((c, i) => (
              <div key={i} onClick={() => goToCar(i)}
                style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.75rem", cursor: "pointer" }}>
                <div style={{
                  width: "56px", height: "56px", borderRadius: "50%",
                  background: `radial-gradient(circle at 35% 35%, ${c.color}, ${c.accent})`,
                  border: i === activeCarIdx ? `3px solid ${c.color}` : "3px solid transparent",
                  boxShadow: i === activeCarIdx ? `0 0 20px ${c.color}66` : "none",
                  transition: "all 0.4s",
                }} />
                <span style={{ fontSize: "0.65rem", fontFamily: "'Montserrat', sans-serif", color: "rgba(240,237,232,0.5)", letterSpacing: "0.1em" }}>
                  {c.name.split(" ").slice(-1)[0]}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section style={{ ...styles.section, background: "#030609" }}>
        <p style={styles.sectionSub}>Client Stories</p>
        <h2 style={styles.sectionTitle}>What They <span style={styles.accent}>Say</span></h2>
        <div style={{ height: "0.5px", background: `linear-gradient(90deg, transparent, ${car.color}, transparent)`, margin: "2rem auto 3rem", width: "200px", transition: "background 0.4s" }} />
        <div style={styles.testimonialsGrid}>
          {testimonials.map((t, i) => (
            <div key={i} style={styles.testimonialCard} className="hover-glow">
              <div style={styles.stars}>{"★".repeat(t.stars)}</div>
              <p style={styles.testimonialText}>"{t.text}"</p>
              <div style={styles.testimonialAuthor}>{t.name}</div>
              <div style={styles.testimonialRole}>{t.role}</div>
            </div>
          ))}
        </div>
      </section>

      {/* BOOKING */}
      <section style={styles.bookingSection}>
        <p style={{ ...styles.sectionSub, color: "rgba(240,237,232,0.5)" }}>Seamless Reservation</p>
        <h2 style={{ ...styles.sectionTitle, marginBottom: "3rem" }}>Reserve Your <span style={{ color: car.color, transition: "color 0.4s" }}>Experience</span></h2>

        <div style={styles.bookingCard}>
          <div style={styles.stepIndicator}>
            {bookingSteps.map((s, i) => (
              <>
                <div key={s} style={styles.step(bookingStep === i, bookingStep > i)} onClick={() => setBookingStep(i)}>
                  {bookingStep > i ? "✓" : i + 1}
                </div>
                {i < bookingSteps.length - 1 && <div style={styles.stepLine} />}
              </>
            ))}
          </div>

          <h3 style={{ fontSize: "1.5rem", marginBottom: "2rem", textAlign: "center" }}>{bookingSteps[bookingStep]}</h3>

          {bookingStep === 0 && (
            <div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1rem", marginBottom: "2rem" }}>
                {cars.map((c, i) => (
                  <div key={c.id} onClick={() => { goToCar(i); }}
                    style={{ padding: "1rem", borderRadius: "6px", cursor: "pointer", textAlign: "center", border: i === activeCarIdx ? `2px solid ${c.color}` : "2px solid rgba(255,255,255,0.1)", background: i === activeCarIdx ? `${c.color}15` : "transparent", transition: "all 0.3s" }}>
                    <div style={{ fontSize: "0.7rem", fontFamily: "'Montserrat', sans-serif", color: i === activeCarIdx ? c.color : "rgba(240,237,232,0.5)", marginBottom: "0.25rem", letterSpacing: "0.1em" }}>{c.category}</div>
                    <div style={{ fontSize: "0.9rem", fontWeight: 600 }}>{c.name.split(" ").slice(0, 2).join(" ")}</div>
                    <div style={{ fontSize: "1rem", fontWeight: 700, color: c.color, marginTop: "0.25rem" }}>${c.price}/day</div>
                  </div>
                ))}
              </div>
              <button style={{ ...styles.primaryBtn, width: "100%", padding: "1.1rem" }} onClick={() => setBookingStep(1)}>
                Continue with {car.name.split(" ").slice(0,2).join(" ")} →
              </button>
            </div>
          )}

          {bookingStep === 1 && (
            <div>
              <div style={styles.inputRow}>
                <div style={styles.inputGroup}>
                  <label style={styles.inputLabel}>Pick-Up Date</label>
                  <input type="date" style={styles.input} />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.inputLabel}>Return Date</label>
                  <input type="date" style={styles.input} />
                </div>
              </div>
              <div style={styles.inputRow}>
                <div style={styles.inputGroup}>
                  <label style={styles.inputLabel}>Full Name</label>
                  <input type="text" placeholder="Your full name" style={styles.input} />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.inputLabel}>Phone Number</label>
                  <input type="tel" placeholder="+1 (000) 000-0000" style={styles.input} />
                </div>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.inputLabel}>Pick-Up Location</label>
                <input type="text" placeholder="Enter city or address" style={styles.input} />
              </div>
              <div style={{ display: "flex", gap: "1rem" }}>
                <button style={{ ...styles.secondaryBtn, flex: 1, padding: "1rem" }} onClick={() => setBookingStep(0)}>← Back</button>
                <button style={{ ...styles.primaryBtn, flex: 2, padding: "1rem" }} onClick={() => setBookingStep(2)}>Review Booking →</button>
              </div>
            </div>
          )}

          {bookingStep === 2 && (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>✅</div>
              <h3 style={{ fontSize: "1.8rem", marginBottom: "1rem" }}>Reservation Confirmed</h3>
              <p style={{ color: "rgba(240,237,232,0.6)", fontFamily: "'Montserrat', sans-serif", fontSize: "0.9rem", lineHeight: 1.7, marginBottom: "2rem" }}>
                Your {car.name} experience has been reserved. Our concierge team will reach out within 2 hours to confirm all details and arrange delivery.
              </p>
              <div style={{ background: "rgba(255,255,255,0.05)", borderRadius: "8px", padding: "1.5rem", marginBottom: "2rem", border: `1px solid ${car.color}33` }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.5rem" }}>
                  <span style={{ fontFamily: "'Montserrat', sans-serif", color: "rgba(240,237,232,0.5)", fontSize: "0.85rem" }}>Vehicle</span>
                  <span style={{ fontWeight: 600 }}>{car.name}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span style={{ fontFamily: "'Montserrat', sans-serif", color: "rgba(240,237,232,0.5)", fontSize: "0.85rem" }}>Daily Rate</span>
                  <span style={{ fontWeight: 700, color: car.color, fontSize: "1.1rem", transition: "color 0.4s" }}>${car.price}</span>
                </div>
              </div>
              <button style={{ ...styles.primaryBtn, padding: "1rem 3rem" }} onClick={() => setBookingStep(0)}>Make Another Reservation</button>
            </div>
          )}
        </div>
      </section>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <div style={styles.footerGrid}>
          <div>
            <div style={{ ...styles.footerBrand, background: `linear-gradient(135deg, ${car.color}, ${car.accent})`, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", transition: "all 0.4s" }}>GoRoute</div>
            <p style={styles.footerDesc}>The world's most exclusive automotive rental experience. We curate the finest machines for those who appreciate the extraordinary.</p>
          </div>
          {[
            { title: "Fleet", links: ["Exotic Cars", "Luxury Sedans", "Sports Cars", "SUVs"] },
            { title: "Services", links: ["Chauffeur", "Track Days", "Corporate", "Events"] },
            { title: "Company", links: ["About Us", "Locations", "Press", "Careers"] },
          ].map(col => (
            <div key={col.title}>
              <div style={styles.footerHeading}>{col.title}</div>
              <ul style={styles.footerLinks}>
                {col.links.map(l => (
                  <li key={l} style={styles.footerLink} className="footer-link-hover">{l}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div style={styles.footerBottom}>
          <div style={styles.footerCopy}>© 2025 GoRoute. All rights reserved.</div>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            {cars.map((c, i) => (
              <div key={i} onClick={() => goToCar(i)} style={{ width: "8px", height: "8px", borderRadius: "50%", background: i === activeCarIdx ? c.color : "rgba(255,255,255,0.2)", cursor: "pointer", transition: "all 0.4s" }} />
            ))}
          </div>
          <div style={styles.footerCopy}>Powered by Nesma Software Team</div>
        </div>
      </footer>
    </div>
  );
}
